import {ImageValue, VideoValue, FileProps} from '../application/types';
type MediaValue = ImageValue | VideoValue | FileProps | string;
type TranslateMediaValueToFilePropsProps = FileProps | null;

export function TranslateMediaValueToFileProps(mediaValue: MediaValue, externalVideoUrl: string | null = null) : FileProps | undefined {
  if (typeof mediaValue === 'string') {
    return {
      path: mediaValue,
      preview: mediaValue,
    };
  }
  
  if((mediaValue && 'uri' in mediaValue && mediaValue.uri) || externalVideoUrl ){
    let mediaTranslated: FileProps;
    mediaTranslated = {
      ...(typeof mediaValue === 'object' ? mediaValue : {}),
      path: `${mediaValue && 'uri' in mediaValue ? mediaValue.uri : ''}`,
      preview: `${mediaValue && 'uri' in mediaValue ? mediaValue.uri : ''}`,
    }
    if(externalVideoUrl){
      mediaTranslated = {
        path: `${externalVideoUrl}`,
        preview: `${externalVideoUrl}`,
      }
    }
    return mediaTranslated;
  } else if (mediaValue && 'type' in mediaValue && typeof mediaValue.type === 'string' && new RegExp(['video/','cover/', 'image/', 'audio/', 'avatar/',  'attachment/'].join("|")).test(mediaValue.type) ){
    return mediaValue as FileProps;
  }
  
  return undefined;
}